export default function (v) {
  let fv = v % 1;     // fractional part
  let d = v - fv;     // integer part (degrees)
  fv = Math.abs(fv);
  let m = fv * 60;    // minutes
  let mf = m % 1;     // fractional part of minutes
  let mi = m - mf;    // integer part of minutes
  let s = String((Math.round(mf * 600) / 10).toFixed(1))  // seconds
  if (s === '60.0') {
    mi += 1
    s = '00.0'
  } else {
    s = s.padStart(4, '0');  // length is 2 digits of seconds + decimal point + 1/10 of second
  }
  mi = String(mi).padStart(2, '0');
  // minutes and seconds symbols below are U+2032 and U+2033 respectively
  return `${d}°&nbsp;${mi}′&nbsp;${s}″`;
}
